import { combineReducers } from 'redux';

import {
  ACTION_ADD_REVENUES,
} from '../actionTypes';


const byId = (state = {}, action) => {
  switch (action.type) {
    case ACTION_ADD_REVENUES:
      return { ...state, ...action.payload.revenues };

    default:
      return state;
  }
};

export default combineReducers({
  byId,
});
